// extracted by mini-css-extract-plugin
module.exports = {"course-authors":"card-helpers_course-authors__fEfn1","card-title":"card-helpers_card-title__6f0DQ"};